import type { ReactNode } from "react";
import { cn } from "@shared/lib/utils";

/** การ์ดตัวเลขหนึ่งใบ — label / ค่า / คำอธิบายใต้ค่า */
export function OvKpi({
  label,
  value,
  sub,
  tone,
}: {
  label: ReactNode;
  value: ReactNode;
  sub?: ReactNode;
  /** is-bad = ทำให้ตัวเลขเป็นสีเตือน (ใช้กับ SLA ที่ต่ำกว่าเกณฑ์) */
  tone?: "is-bad";
}) {
  return (
    <div className={cn("ov-kpi", tone)}>
      <div className="ov-kpi-label">{label}</div>
      <div className="ov-kpi-value">{value}</div>
      <div className="ov-kpi-sub muted">{sub ?? ""}</div>
    </div>
  );
}
